<div class="row">
  <div class="col-12 m-t-xl">
    <h3 [innerHtml]="pageTitle"></h3>
  </div>
</div>
<div id="gallery">
  <!-- gallery -->
  <div class="gallery row m-t-lg">
    <div class="gallery-stage col-12 col-sm-10 offset-sm-1">
      <div class="stage-container">
        <ng-container *ngIf="isVideo && itemArray">
          <div class="image" ng-mouseover="isHover=true" ng-mouseleave="isHover=false">
            <video
              #videoPlayer
              (click)="pauseVideo()"
              [src]="itemArray[activeVideo]?.videoUrl | safeUrl"
              controls
              height="400"
              width="100%"
            ></video>
            <a
              *ngIf="isVideoPaused"
              href="javascript:void(0);"
              (click)="playVideo()"
              class="play-button"
              id="cta-default-593"
            ></a>
          </div>
        </ng-container>
        <ng-container *ngIf="itemArray && !isVideo">
          <div class="image text-center" ng-mouseover="isHover=true" ng-mouseleave="isHover=false">
            <img
              class="img-responsive"
              [src]="itemArray[activeImage]?.imageUrl | safeUrl"
              alt="Product Image"
            />
          </div>
        </ng-container>
      </div>
    </div>
    <!-- thumbs section -->
    <div class="gallery-thumbs col-12 col-sm-10 offset-sm-1">
      <a
        class="left-arrow"
        attr.aria-label="{{ nextButton }}"
        href="javascript:void(0);"
        (click)="moveLeft()"
        [ngClass]="{ disable: !leftActive }"
        id="cta-next-button-5"
        ><i class="fa fa-angle-left"></i
      ></a>
      <div class="thumbs-container">
        <ul [id]="dynamicId" class="thumbs-strip">
          <ng-container *ngIf="isVideo">
            <li
              class="thumb-item video-thumb"
              [ngClass]="{ selected: i + 1 == videothumbSelected }"
              *ngFor="let video of itemArray; let i = index"
            >
              <a
                href="javascript:void(0);"
                (click)="pauseVideo(); showVideo(i)"
                id="cta-default-594_{{ i }}"
              >
                <video height="100%">
                  <source [src]="video.videoUrl | safeUrl" />
                </video>
              </a>
            </li>
          </ng-container>
          <ng-container *ngIf="!isVideo">
            <li
              class="thumb-item"
              [ngClass]="{ selected: i + 1 == imagethumbSelected }"
              *ngFor="let img of itemArray; let i = index"
            >
              <a
                attr.aria-label="{{ image }} {{ i + 1 }} {{ constantOf }} {{ itemArray.length }}"
                href="javascript:void(0);"
                (click)="showImage(i)"
                id="cta-length-2_{{ i }}"
              >
                <img
                  class="img-responsive"
                  [src]="img.imageUrl | safeUrl"
                  alt="Product Thumbnail"
                />
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
      <a
        class="right-arrow"
        attr.aria-label="{{ nextButton }}"
        href="javascript:void(0);"
        (click)="moveRight()"
        [ngClass]="{ disable: !rightActive }"
        id="cta-next-button-6"
        ><i class="fa fa-angle-right"></i
      ></a>
    </div>
  </div>
  <!--/ div#thumbs -->
  <div class="m-t-xl"></div>
</div>
